<router-outlet (activate)="onActivate(false)"></router-outlet>

<eid-dev-tools *ngIf="showDevTools === true"></eid-dev-tools>
